<template>
  <v-layout row>
    <v-flex>
      <v-card>
        <v-card-title 
          color="primary" 
          primary-title 
          class="title mb-0 pb-0"
        >
          Dataset Info
        </v-card-title>
        <v-card-text 
          v-if="editMode" 
          color="secondary"
        >
          <v-text-field
            label="Dataset Website URL"
            placeholder="ex. https://mcity.umich.edu"
            v-model="datasetWebsite"
            :hint="`${fieldLength(datasetWebsite)}/200 Characters`"
            :error-messages="urlFieldErrors($v.datasetWebsite)"
            @input="$v.datasetWebsite.$touch()"
            @blur="$v.datasetWebsite.$touch()"
            clearable
            data-cy="dataset-website-url"
          ></v-text-field>
          <v-text-field
            label="Dataset Repo URL"
            placeholder="ex. https://github.com/mcity/something"
            v-model="datasetRepo"
            :hint="`${fieldLength(datasetRepo)}/200 Characters`"
            :error-messages="urlFieldErrors($v.datasetRepo)"
            @input="$v.datasetRepo.$touch()"
            @blur="$v.datasetRepo.$touch()"
            clearable
          ></v-text-field>
          <v-text-field
            label="Dataset Readme URL"
            placeholder="ex. https://github.com/mcity/something/README.md"
            v-model="datasetReadme"
            :hint="`${fieldLength(datasetReadme)}/200 Characters`"
            :error-messages="urlFieldErrors($v.datasetReadme)"
            @input="$v.datasetReadme.$touch()"
            @blur="$v.datasetReadme.$touch()"
            clearable
          ></v-text-field>
         <v-text-field
            label="Dataset Project Tracking URL"
            placeholder="ex. https://datasets.um.city/datasets/12"
            v-model="datasetDataset"
            :hint="`${fieldLength(datasetDataset)}/200 Characters`"
            :error-messages="urlFieldErrors($v.datasetDataset)"
            @input="$v.datasetDataset.$touch()"
            @blur="$v.datasetDataset.$touch()"           
            clearable
          ></v-text-field>
          <v-text-field
            label="Access Instructions"
            placeholder="Ex. Send to someone@umich.edu with account number"
            v-model="datasetAccess"
            :hint="`${fieldLength(datasetAccess)}/300 Characters`"
            :error-messages="textFieldErrors($v.datasetAccess)"
            @input="$v.datasetAccess.$touch()"
            @blur="$v.datasetAccess.$touch()"   
            clearable
          ></v-text-field>
        </v-card-text>
        <v-card-text 
          v-if="!editMode" 
          color="secondary"
          :class="{ presentation: getPresentMode }">
          <div>Create Date: {{ dataset.create_date }}</div>
          <div v-show="datasetWebsite">Dataset Website: <a target="_blank" v-bind:href="dataset.dataset_website">{{ dataset.dataset_website }}</a></div>
          <div v-show="datasetRepo">Dataset Repository: <a target="_blank" v-bind:href="dataset.dataset_repo">{{ dataset.dataset_repo }}</a></div>
          <div v-show="datasetDataset">Project Tracking: <a target="_blank" v-bind:href="dataset.dataset_dataset">{{ dataset.dataset_dataset }}</a></div>
          <div v-show="datasetAccess">Access Instructions: {{ dataset.dataset_access }}</div>
        </v-card-text>
        </v-card>
      <v-divider></v-divider>
      <dataset-pi
        :editMode="editMode"
      ></dataset-pi>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { url, maxLength, required } from 'vuelidate/lib/validators'
import { validationMixin } from '../validators.js'
import DatasetPI from './DatasetPI.vue'

export default {
  mixins: [validationMixin],
  components: {
    'dataset-pi': DatasetPI
  },
  props: {
    editMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentDataset',
      'getPresentMode'
    ]),
    dataset () {
      return this.getCurrentDataset
    },
    formTitle () {
      return (this.editedPIIndex | this.editedLCInde) === -1 ? 'New Item' : 'Edit Item'
    },
    datasetCreateDate: {
      get () {
        return this.$store.getters.getDatasetEdits.create_date
      }
    },
    datasetWebsite: {
      get () {
        return this.$store.getters.getDatasetEdits.dataset_website
      },
      set (val) {
        this.setDatasetEdit({
          key: 'dataset_website',
          value: val
        })
      }
    },
    datasetRepo: {
      get () {
        return this.$store.getters.getDatasetEdits.dataset_repo
      },
      set (val) {
        this.setDatasetEdit({
          key: 'dataset_repo',
          value: val
        })
      }
    },
    datasetAccess: {
      get () {
        return this.$store.getters.getDatasetEdits.dataset_access
      },
      set (val) {
        this.setDatasetEdit({
          key: 'dataset_access',
          value: val
        })
      }
    },
    datasetReadme: {
      get () {
        return this.$store.getters.getDatasetEdits.dataset_readme
      },
      set (val) {
        this.setDatasetEdit({
          key: 'dataset_readme',
          value: val
        })
      }
    },
    datasetDataset: {
      get () {
        return this.$store.getters.getDatasetEdits.dataset_dataset
      },
      set (val) {
        this.setDatasetEdit({
          key: 'dataset_dataset',
          value: val
        })
      }
    }
  },
  methods: {
    ...mapMutations([
      'setDatasetEdit',
      'logError',
      'setTopFieldsInvalid'
    ]),
    fieldLength (someField) {
      return someField ? someField.length : 0
    }
  },
  mounted () {
    this.$watch('$v', (newVal, oldVal) => {
      this.setTopFieldsInvalid(newVal.$invalid)
    }, { deep: true })
  },
  validations: {
    datasetWebsite: {
        url,
        maxLength: maxLength(200)
    },
    datasetRepo: {
        url,
        maxLength: maxLength(200)
    },
    datasetDataset: {
        url,
        maxLength: maxLength(200)
    },
    datasetReadme: {
        url,
        maxLength: maxLength(200)
    },
    datasetAccess: {
        required,
        maxLength: maxLength(300)
    }
  }
}
</script>